<br>
<!-- <div *ngIf="formName == 'otherform'">If any other document need to be submitted.<br><br><br></div> -->
<div class="modalAction" *ngIf="pageLoad"></div>
<form #form="ngForm">
    <div class="form-group">
        <div *ngIf="strErrorMessage!=''">
            <div class="alert alert-danger" role="alert">
                {{strErrorMessage}}
            </div>
            <br>
        </div>
        <!-- && !blnShowLoad || !enableSubmitFlag-->
        <div *ngIf="(!windowFlag ) ">
                <div  class="alert alert-danger" role="alert">
                        Form submission / upload document options are not allowed as window for submission is closed for this cycle ({{cycleName}}).
                </div>
                <br>
            </div>
         <!-- <div *ngIf="strErrorMessage=='' && strSuccessMessage!=''">
            <div class="alert alert-success" role="alert">
                {{strSuccessMessage}}
            </div>
            <br>
        </div>  -->
        <app-downloadfile *ngIf="reloadComponent" [cycleFlag]="cycleFlag" [windowFlag]="windowFlag" [selYear]="selYear" [cycleName]="cycleName" [docType]="formName == 'otherform'?'others': formName"></app-downloadfile>
       
        <div *ngIf="windowFlag" class="row">
            <div class="col-md-4 col-sm-6 col-12">
                <div class="field-bg">
                    <input disabled id="NRdocType" name="NRdocType" [(ngModel)]="document.documentType">
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="NRdocType" name="variableText">Document Type</label>
                </div>
                <!-- <div class="field-bg" *ngIf="formName=='otherform'">
                    <input id="NRdocTypeother" name="NRdocTypeother" [(ngModel)]="document.documentType" (blur)="$event.target.value!=''?invDocTypeFlag=false:invDocTypeFlag=true">
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="NRdocTypeother" name="variableText">Document Type</label>
                    <div class="text-danger" *ngIf="invDocTypeFlag == true">Document Type Required.</div>
                </div> -->
            </div>
           
            <div class="col-md-4 col-sm-6 col-12">
                <div class="upload field-bg">
                    <input style="border:none;" type="file" id="NRDocupload{{formName}}" name="NRDocupload{{formName}}" (change)="attachFile($event.target)"
                        accept="image/*,.pdf">
            
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label for="NRDocupload{{formName}}" name="variableText">Attach Document
                        <span class="mandate">*</span>
                        <!-- <span>(.pdf and image files are allowed)</span> -->
                       
                    </label>
                   
                    <div class="text-danger">
                        <span *ngIf="strFileNameError">{{strFileNameError}}</span>
                        <span *ngIf="strFileSizeError">{{strFileSizeError}}</span>
                         <span *ngIf="!strFileNameError && !strFileSizeError && fileValidFlag == false">Valid Document Required.</span>
                    </div>
                    <p class="para" style="font-size:12px !important">Please Note: File size allowed is 5MB and allowed file types are .png,.jpeg,.jpg,.pdf,.tiff</p>
                    
                </div>
                
            </div>
            <div class="col-md-12 col-lg-4 col-12" *ngIf="(formName!='otherform' && formName!='Electronic Form 10F' && formName!='Tax Residence Certificate (TRC)' && formName!='Form 41 (erstwhile E-Form 10F)' &&  formName!='Lower Tax Deduction Certificate (LTDC)')">
                    <a id="downloadTemplateOtherForm" href="{{downloadTempLink}}"  download="{{formName}}" class=" p-2 resetbutton">
                            <span class="saveResetButtonText p-1" name="downloadTemplate">Download Template</span>
                    </a>
            </div>
           
        </div>
        <br/>
        <div *ngIf="windowFlag" class="row">
            
            <div class="col-md-8 col-12">
                <div class="checkbox">
                    <input id="validate{{formName}}" [checked]="decCheck" type="checkbox" (change)="checkConsent($event)">
                    <label class="marL3 check-label" for="validate{{formName}}">
                        <span class="custom-checkboxoptions">I hereby validate the above-mentioned information and have made the necessary modifications wherever
                            required, and I do hereby declare that to the best of my knowledge and belief what is stated
                            above is correct, complete and is truly stated.</span>
                    </label>
                </div>
            </div>
        </div>
        <br/>
        <div  *ngIf="windowFlag" class="row">
            <div class="col-md-8 ">

                <div class="row ng-star-inserted">
                    <div class="col-md-4 col-12">
                       <button id="submit{{formName}}" [disabled]="checkDisableSubmit()" class="saveResetButton" (click)="fnTakeAction()">
                           <span class="saveResetButtonText" name="saveText">Submit</span>
                       </button>
                    </div>
                    <div class="col-md-4 col-12">
                        <button id="cancel{{formName}}" class="resetbutton" (click)="reset()">
                            <span class="saveResetButtonText" name="CancelText">Cancel</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>